import * as React from "react";
import * as Yup from "yup";
import { useTl, useApiService, useCrudApi } from "../../../../hooks";
import { useHistory } from "react-router";
import { useGlobalData } from "../../../../contexts";
import { ERoutes } from "../../../../ERoutes";
import { ETLCodes } from "../../../../locales";
import { SmallFormGenerator } from "../../../../components";
import { FieldGroup, FGTextInput, FGTextAreaInput } from "nsitools-react";
import { EmailApi, EmailDto } from "../../../../api";

export interface IEmailDetailPageProps {
  mailTemplateId: number;
  editMode: boolean;
}

export const EmailDetailPage: React.FunctionComponent<IEmailDetailPageProps> = ({
  mailTemplateId,
  editMode,
}) => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(EmailApi);
  const { languages } = useGlobalData();

  const { data, loading, saveItem, saving, deleteItem, deleting } = useCrudApi(
    {
      getApiFn: (id = mailTemplateId) => api.getEmail(id),
      saveApiFn: (d: EmailDto) => api.saveEmail(d),
      onSavedRoute: (d) => `${ERoutes.email}/${d.mailTemplateId}/detail/edit`,
      deleteApiFn: (d) => {},
    },
    [mailTemplateId]
  );

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({});
  }, []);

  return (
    data && (
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={editMode}
        loading={loading}
        onCancel={() => history.push(ERoutes.email)}
        saving={saving}
        deleting={deleting}
        showDeleteButton={false}
        onDelete={deleteItem}
        validationSchema={FormSchema}
      >
        <FieldGroup>
          <FGTextInput
            name={`mailDescription`}
            label={t(ETLCodes.Description)}
            readonly
          />
        </FieldGroup>
        {data.mailContent.map((item, index) => {
          return (
            <FieldGroup
              key={index}
              fieldsetProps={{
                title: languages.find((c) => c.languageId === item.languageId)
                  ?.languageCode,
                collapsable: true,
              }}
            >
              <FGTextInput
                name={`mailContent[${index}].subject`}
                label={t(ETLCodes.Subject)}
              />
              <FGTextAreaInput
                name={`mailContent[${index}].body`}
                label={t(ETLCodes.Body)}
                rows={10}
              />
            </FieldGroup>
          );
        })}
      </SmallFormGenerator>
    )
  );
};
